"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MPShop
 * API documentation
 *
 * The version of the OpenAPI document: 0.0.1-alpha.58
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOrderaddonsRequestToJSON = exports.GetOrderaddonsRequestFromJSONTyped = exports.GetOrderaddonsRequestFromJSON = exports.instanceOfGetOrderaddonsRequest = void 0;
var ProductType_1 = require("./ProductType");
/**
 * Check if a given object implements the GetOrderaddonsRequest interface.
 */
function instanceOfGetOrderaddonsRequest(value) {
    var isInstance = true;
    isInstance = isInstance && "anchorProduct" in value;
    isInstance = isInstance && "orderId" in value;
    return isInstance;
}
exports.instanceOfGetOrderaddonsRequest = instanceOfGetOrderaddonsRequest;
function GetOrderaddonsRequestFromJSON(json) {
    return GetOrderaddonsRequestFromJSONTyped(json, false);
}
exports.GetOrderaddonsRequestFromJSON = GetOrderaddonsRequestFromJSON;
function GetOrderaddonsRequestFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'anchorProduct': (0, ProductType_1.ProductTypeFromJSON)(json['anchorProduct']),
        'orderId': json['orderId'],
    };
}
exports.GetOrderaddonsRequestFromJSONTyped = GetOrderaddonsRequestFromJSONTyped;
function GetOrderaddonsRequestToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'anchorProduct': (0, ProductType_1.ProductTypeToJSON)(value.anchorProduct),
        'orderId': value.orderId,
    };
}
exports.GetOrderaddonsRequestToJSON = GetOrderaddonsRequestToJSON;
